import React, { FC, ReactNode } from "react"

import "./Hero.scss"

type HeroProps = {
  children: ReactNode,
  className?: string | null | undefined
  [restProps: string]: any
}

const Hero: FC<HeroProps> = ({ children, className, ...restProps }) => (
  <section className={`Hero ${className ? className : ""}`} {...restProps}>
    {children}
  </section>
)

export default Hero
